class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field, attr = null) {
        if (this.errors.hasOwnProperty(field)){
            if (attr && this.errors[field].hasOwnProperty(attr)){
                return true
            }
            else if(attr) {
                return null
            }
            return true
        }
        return null;
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     * @param {number} index - Index of the array element (optional)
     * @param {string} attr - Attribute name (optional)
     */
    hasArray(field, index = null, attr = null) {
        if (this.errors.hasOwnProperty(field)) {
            if (index !== null && Array.isArray(this.errors[field]) && this.errors[field][index]) {
                if (attr && this.errors[field][index].hasOwnProperty(attr)) {
                    return true;
                } else if (attr) {
                    return null;
                }
                return true;
            } else if (Array.isArray(this.errors[field]) && index === null) {
                return this.errors[field].length > 0;
            }
        }
        return null;
    }

    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field, attr = null) {
        if (this.errors[field]) {
            if (attr && this.errors[field][attr]){
                return this.errors[field][attr][0];
            }
            return this.errors[field][0];
        }
    }

    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     * @param {number} index - Index of the array element (optional)
     * @param {string} attr - Attribute name (optional)
     */
    getArray(field, index = null, attr = null) {
        if (this.errors[field]) {
            if (index !== null && Array.isArray(this.errors[field]) && this.errors[field][index]) {
                if (attr && this.errors[field][index][attr]) {
                    return this.errors[field][index][attr][0];
                }
                return this.errors[field][index][0];
            } else if (Array.isArray(this.errors[field]) && index === null) {
                return this.errors[field][0];
            }
        }
    }


    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }
}

export default Errors
